<template>
    <div class="d-inline-block">
        <div class="d-inline-block mt-1 mr-2"> {{ trans[locale].from }} </div>
        <div class="d-inline-block align-top mb-2 filter-date-range">
            <datetime
                    name="start_date"
                    v-model="start_date"
                    :max-datetime="end_date"
                    value-zone="local"
                    type="date"
                    class="form-control"
                    placeholder="YYYY-MM-DD"
                    title=""
                    :week-start="7"
                    format="yyyy-LL-dd"
            >
                <template slot="button-cancel" slot-scope="scope">
                    {{ trans[locale].cancel }}
                </template>
                <template slot="button-confirm" slot-scope="scope">
                    {{ trans[locale].confirm }}
                </template>
            </datetime>
        </div>
        <div class="d-inline-block mt-1 ml-2 mr-2"> {{ trans[locale].to }} </div>
        <div class="d-inline-block align-top mb-2 filter-date-range">
            <datetime
                    name="end_date"
                    v-model="end_date"
                    :min-datetime="start_date"
                    value-zone="local"
                    type="date"
                    class="form-control"
                    placeholder="YYYY-MM-DD"
                    title=""
                    :week-start="7"
                    format="yyyy-LL-dd"
            >
                <template slot="button-cancel" slot-scope="scope">
                    {{ trans[locale].cancel }}
                </template>
                <template slot="button-confirm" slot-scope="scope">
                    {{ trans[locale].confirm }}
                </template>
            </datetime>
        </div>
    </div>
</template>

<script>
    import {Datetime} from 'vue-datetime';
    export default {
        data() {
            return {
                trans: {
                    'zh-HK': {
                        'cancel': '取消',
                        'confirm': '確定',
                        'from': '由',
                        'to': '至',
                    },
                    'en': {
                        'cancel': 'Cancel',
                        'confirm': 'Confirm',
                        'from': 'From',
                        'to': 'To',
                    }
                },
                selected_start: '',
                selected_end: '',
                start_date: this.init_start_date,
                end_date: this.init_end_date,
                locale: window.locale,
            }
        },
        components: {
            Datetime,
        },
        props: {
            filter: {
                type: String,
                required: true,
            },
            trigger_filter_refresh: {
                type: Boolean,
                default: false,
            },
            ignore_refresh_signal: {
                type: Boolean,
                default: false,
            },
            refresh_url: {
                type: String,
                default: '',
            },
            init_start_date: {
                required: false,
                type: String,
                default: () => {
                    return moment().format("YYYY-MM-DD");
                }
            },
            init_end_date: {
                required: false,
                type: String,
                default: () => {
                    return moment().format("YYYY-MM-DD");
                }
            },
        },
        beforeDestroy() {
        },
        mounted() {
            this.selected_start = this.start_date;
            this.selected_end = this.end_date;

            this.updateValueAction(this.filter + '_start', this.selected_start);
            this.updateValueAction(this.filter + '_end', this.selected_end);

            if (this.trigger_filter_refresh) {
                this.$nextTick(() => {
                    window.eventHub.$emit('filter_refresh');
                });
            }
        },
        methods: {

            updateValueAction(filter, values) {
                let _value = _.isNull(values) || values == '' ? null : moment(values).format('YYYY-MM-DD');
                let _filter = filter

                // emit a refresh signal to other filters
                if (this.trigger_filter_refresh) {
                    window.eventHub.$emit('filter_refresh', _value);
                }

                this.$store.commit('setFilter', {_filter, _value});
            },
        },
        watch: {
            start_date: {
                handler(after, before) {
                    this.updateValueAction(this.filter + '_start', this.start_date);
                    this.updateValueAction(this.filter + '_end', this.end_date);
                    if (this.trigger_filter_refresh) {
                        this.$nextTick(() => {
                            window.eventHub.$emit('filter_refresh');
                        });
                    }
                }
            },
            end_date: {
                handler(after, before) {
                    this.updateValueAction(this.filter + '_start', this.start_date);
                    this.updateValueAction(this.filter + '_end', this.end_date);
                    if (this.trigger_filter_refresh) {
                        this.$nextTick(() => {
                            window.eventHub.$emit('filter_refresh');
                        });
                    }
                }
            }
        },
        computed: {

        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Select/FilterDateRange.vue